import Box from '@mui/material/Box';
import { Skeleton } from '@mui/material';

const FormSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        maxWidth: '40%',
        alignItems: 'start',
        justifyContent: 'start',
      }}
    >
      <Skeleton
        width={'120px'}
        height={'28px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <Skeleton
        width={'100%'}
        height={'40px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <Skeleton
        width={'100%'}
        height={'40px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <Skeleton
        width={'100%'}
        height={'40px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <Skeleton
        width={'100%'}
        height={'40px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <Skeleton
        width={'100%'}
        height={'40px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <Skeleton
        width={'100%'}
        height={'40px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Skeleton
          width={'160px'}
          height={'40px'}
          sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
        />
        <Skeleton
          width={'160px'}
          height={'40px'}
          sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
        />
      </Box>
    </Box>
  );
};

export default FormSkeleton;